export default "__VITE_ASSET__Dhcfe$Vu__"